module.exports = __webpack_public_path__ + "static/media/declinedRequest.d3ada788.svg";